import React from "react";
import { Row, Col } from "react-bootstrap";
import MetricCard from "./MetricCard";

// Phase 5, §13. TAT compliance is "Not Applicable" (never 0%) when there
// are no due-dated completions to measure against.
export default function TatComplianceSummary({ accountability }) {
  const a = accountability || {};
  const compliance = a.tasksCompletedWithDue ? (a.tasksCompletedOnTime / a.tasksCompletedWithDue) * 100 : null;

  return (
    <Row className="g-3">
      <Col xs={6} md={4}>
        <MetricCard label="TAT Compliance" value={compliance} isPercentage direction="HIGHER_IS_BETTER" icon="fa-gauge-high" subtext={a.tasksCompletedWithDue ? `${a.tasksCompletedOnTime}/${a.tasksCompletedWithDue} on time` : "No due-dated completions"} />
      </Col>
      <Col xs={6} md={4}><MetricCard label="Tasks Completed On Time" value={a.tasksCompletedOnTime} direction="HIGHER_IS_BETTER" icon="fa-clock" /></Col>
      <Col xs={6} md={4}><MetricCard label="Average Cycle Time" value={a.avgCycleHours} unit="hours" direction="LOWER_IS_BETTER" icon="fa-stopwatch" /></Col>
    </Row>
  );
}
